<template>
  <div class="range">
    <span>{{ prefix }}</span>
    <span class="cx-dropdown">
      <a @click.prevent="show = !show"
        href="#" class="cx-dropdown__trigger"
      >
        <span>{{ value }} <i class="fal fa-angle-down"></i></span>
      </a>
      <div v-if="show" class="cx-dropdown__content">
        <ul class="cx-list cx-list--vertical cx-t02">
          <li v-for="option in options" :key="option" class="cx-list__item">
            <a @click.prevent="changeValue(option)" href="#" class="cx-link">
              {{ option }}
              <span class="cx-link__icon" v-if="value === option">
                <i class="fal fa-check" />
              </span>
            </a>
          </li>
        </ul>
      </div>
    </span>
    <span>{{ surfix }}</span>
  </div>
</template>

<script>
export default {
  name: 'sight-map-map-container-range',
  props: {
    value: {
      type: Number,
      default() {
        return 200;
      },
    },
  },
  data() {
    return {
      show: false,
      options: [
        // 50,
        100,
        200,
        500,
        1000,
        2000,
      ],
    };
  },
  computed: {
    prefix() {
      return (this.$t('action.searchRange').match(/(.*){x}/) || [])[1];
    },
    surfix() {
      return (this.$t('action.searchRange').match(/{x}(.*)/) || [])[1];
    },
  },
  methods: {
    changeValue(value) {
      this.$emit('changed', value);
      this.show = false;
    },
  },
};
</script>
